import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  timerSection: {
    width: '100%',
    paddingHorizontal: 10,
    backgroundColor: '#1F1D1D',
    flexDirection: 'row',
    alignItems: 'center',
    height: 18,
    marginBottom: 2
  },
  timerContainer: {
    flex: 1,
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%'
  },
  blueGradient: {
    height: '100%',
    width: '50%',
    borderRadius: 3,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  timeMarker: {
    position: 'absolute',
    height: '100%',
    width: 4,
    backgroundColor: '#FFFFFF',
    shadowColor: '#FFFFFF',
    shadowOffset: {width: 0, height: 0},
    shadowOpacity: 0.78,
    shadowRadius: 5,
    elevation: 5,
    zIndex: 1
  },
  timerDisplay: {
    position: 'absolute',
    left: '50%',
    transform: [{translateX: -31}],
    height: 30,
    width: 62,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    zIndex: 2,
    top: -6
  },
  timerText: {
    color: '#FFFFFF',
    fontSize: 14
  },
  redGradient: {
    height: '100%',
    width: '50%',
    borderRadius: 3,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    transition: 'background-color 0.05s ease'
  },
  scoreSection: {
    width: '100%',
    marginBottom: 2,
    marginTop: 2,
    paddingHorizontal: 10,
    position: 'relative',
    zIndex: 1
  },
  scoreBarContainer: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1
  },
  multiplierContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    width: 55,
    height: 44,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    borderWidth: 1,
    marginRight: 2,
    zIndex: 2
  },
  multiplierFlashEffect: {
    shadowColor: '#7DF9FF',
    shadowOffset: {width: 0, height: 0},
    shadowOpacity: 0.8,
    shadowRadius: 10
  },
  multiplierGradient: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: 8
  },
  multiplierText: {
    fontSize: 24,
    fontWeight: '600',
    fontFamily: 'Poppins_600SemiBold',
    textAlign: 'center'
  },
  multiplierTextFlashEffect: {
    textShadowColor: '#7DF9FF',
    textShadowOffset: {width: 0, height: 0},
    textShadowRadius: 10
  },
  scoreBarMain: {
    flex: 1,
    height: 22,
    borderRadius: 3,
    overflow: 'visible',
    position: 'relative',
    zIndex: 1
  },
  scoreBarBackground: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: 3,
    zIndex: 0
  },
  accumulatorBar: {
    position: 'absolute',
    height: '100%',
    right: 0,
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    zIndex: 1,
    overflow: 'visible',
    shadowColor: '#F2F7FF',
    shadowOffset: {width: -4, height: 0},
    shadowOpacity: 0.8,
    shadowRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(242, 247, 255, 0.4)'
  },
  accumulatorGradient: {
    width: '100%',
    height: '100%',
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    position: 'relative',
    zIndex: 0,
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    flexBasis: 'auto',
    alignItems: 'stretch',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    textAlign: 'center'
  },
  scoreText: {
    position: 'absolute',
    width: '100%',
    textAlign: 'center',
    color: '#243544',
    fontSize: 20,
    fontWeight: '600',
    fontFamily: 'Poppins_600SemiBold',
    zIndex: 3,
    top: '40%',
    transform: [{translateY: -10}]
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    color: '#FFFFFF',
    fontSize: 16,
  }
});
